import React from 'react';
import GeckoFieldBase from '../_base';
import { APP_CONST } from '../../../../constants';

class GeckoFieldText extends GeckoFieldBase {

	attrs() {
		return {
			id             : this.renderId(),
			[`aria-label`] : this.renderAriaLabel(),
			className      : 'col-sm form-control gecko-ui-material',
			type           : this.getType(),
			autoCorrect    : this.isEmail() ? 'on' : 'off',
			autoCapitalize : this.isEmail() ? 'words' : 'none',
			autoComplete   : this.isEmail() ? 'on' : 'off',
			disabled       : this.isDisabled(),
			onChange       : this.handleChange.bind(this),
			onBlur         : this.handleBlur.bind(this),
			placeholder    : this.config().placeholder || this.field().placeholder,
			value          : this.value(),
			ref: this.ref(),
			...this.attributes()
		};
	}

	getType()
	{
		switch(this.field().type) {
			case 'email':
				return 'email';
			case 'tel':
				return 'tel';
			default:
				return 'text';
		}
	}

	isEmail() {
		return this.field().type === APP_CONST.FIELD_TYPE_EMAIL;
	}

	render() {
		return (<input {...this.attrs()} />);
	}

}

export default GeckoFieldText;